import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditorHandle } from '@factorialco/f0-react/dist/experimental'
import { Tabs } from '@factorialco/f0-react/dist/experimental'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { AiChat } from 'modules/meetings/components/AiChat'
import { MeetingNotes } from 'modules/meetings/components/MeetingNotes'
import { useMeeting } from 'modules/meetings/lib/hooks/useMeeting'

import { Transcript } from './components/Transcript'

export const SideBar = () => {
  const { canUseAI, meeting, meetingId } = useMeeting()
  const { employee: currentEmployee } = useCurrentSession()
  const otherAttendee = meeting?.attendees?.filter(
    (attendee) => attendee.employee?.id !== currentEmployee?.id
  )?.[0]

  const [activeTab, setActiveTab] = useState<'notes' | 'transcript' | 'ai_chat'>('notes')
  const textEditorRef = useRef<NotesTextEditorHandle>(null)

  return (
    <>
      <Box paddingTop="s12">
        <Tabs
          activeTabId={activeTab}
          tabs={[
            {
              index: true,
              id: 'notes',
              label: i18n.t('meetings.room.sidebar.notes'),
              onClick: () => {
                track(trackingEvents.meetings.RoomOpenNotes)
                setActiveTab('notes')
              },
            },
            canUseAI && {
              id: 'ai_chat',
              label: i18n.t('meetings.room.sidebar.ai_chat'),
              onClick: () => {
                track(trackingEvents.meetings.RoomOpenAIchat)
                setActiveTab('ai_chat')
              },
            },
            {
              id: 'transcript',
              label: i18n.t('meetings.room.sidebar.transcript'),
              onClick: () => {
                track(trackingEvents.meetings.RoomOpenTranscript)
                setActiveTab('transcript')
              },
            },
          ].filter(Boolean)}
        />
      </Box>
      {activeTab === 'transcript' && <Transcript />}
      {activeTab === 'ai_chat' && canUseAI && (
        <AiChat
          meetingId={String(meetingId)}
          textEditorRef={textEditorRef}
          otherAttendeeFirstname={otherAttendee?.employee?.firstName || ''}
        />
      )}
      <MeetingNotes
        textEditorRef={textEditorRef}
        hideNotes={activeTab !== 'notes'}
        meetingState="post"
      />
    </>
  )
}
